import { createSimpleSelector } from '../selector-utils';
import { createActionsWithReducer } from '../utils';
import { GenericCustomActionsCreator, GenericStoreCustomActions } from './types';

export interface GenericStoreOptions<T> {
  actions: GenericCustomActionsCreator<T>;
  initialState: T;
}

export const createGenericStore = <T extends object>() => <U extends GenericStoreOptions<T>>(
  namespace: string,
  options: U,
) => {
  const baseSelector = createSimpleSelector(
    (root: any) => <T>root[namespace],
    state => state,
  );

  const { actions, reducer } = createActionsWithReducer(
    namespace,
    options.initialState,
    <GenericStoreCustomActions<U>>options.actions(),
  );

  const selectors = {
    state: baseSelector,
  };

  return {
    namespace,
    selectors,
    actions,
    reducer,
  };
};
